import { FC } from 'react'

export const NoContent: FC = () => {
  return <p className="text-[1.25rem] font-bold text-tdplprussian">No Content</p>
}
